import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import s from './Loading.scss';

export function Loading({ ratio = 1 }: { ratio: number }) {
	useStyles(s);
	return (
		<div
			className="image__loading-state"
			style={{ aspectRatio: `${ratio}` }}
		/>
	);
}
